import { Card } from '../components/ui'
import { useSession } from '../lib/session'

/**
 * Where a user with no dashboard grants lands.
 *
 * `APPLICATION_SPEC.md` §2.2: *"A user with no dashboard grants still has an
 * account. `/` must land somewhere sensible and say so, not error."* This is
 * that somewhere.
 */
export function NoAccess() {
  const { me } = useSession()
  return (
    <div style={{ maxWidth: '34rem' }}>
      <Card title="No Dashboards Yet">
        <p className="m-0 text-sm" style={{ color: 'var(--text-secondary)' }}>
          Your Account Is Active, but an Administrator Has Not Given It Access to
          Any Dashboards yet. Ask Them to Grant Stories, Spotlights or Channel
          Overview.
        </p>
        <p className="mt-3 mb-0 text-sm" style={{ color: 'var(--text-label)' }}>
          Signed in As {me?.email}.
        </p>
      </Card>
    </div>
  )
}
